import { t } from "@lingui/macro";
import * as React from "react";
import { Path, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const PeopleIndicatorIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`People Indicator`} {...props}>
    <Rect
      width={12.5}
      height={12.5}
      x={0.75}
      y={0.75}
      fill="none"
      stroke="currentColor"
      rx={1.25}
    />
    <Rect
      width={12.5}
      height={12.5}
      x={0.75}
      y={0.75}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      rx={1.25}
    />
    <Path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m5 9 4-4"
    />
  </Icon>
);
